import { useQuery } from 'react-query';
import { useContext } from 'react';
import { Icon } from '@mui/material';
import { getUserNotifications } from '../../api/notificationsAPI';
import Loader from '../ui/Loader';
import UserNotifications from '../notifications/UserNotifications';

import './NotificationsLink.scss';
import AuthContext from '../../store/auth-context';

const NotificationsLink = () => {
	const authCtx = useContext(AuthContext);
	const roleUser = authCtx.userData.role;

	const {
		isLoading,
		isError,
		error,
		data: notificationsData
	} = useQuery({
		queryKey: ['notifications'],
		queryFn: () => getUserNotifications(),
		retry: false,
		staleTime: 3000000 //5 minutes to refetch
	});

	// if (!notificationsData)
		//this was did like that meanwhile the admin role have info
	if (roleUser === 'ADMIN') {
		return(
			<div className='notifications-link-container dropdown'>
			<Icon
					className='link-icon dropdown-toggle'
					data-bs-toggle='dropdown'
					data-bs-auto-close='outside'
					>
					notifications
				</Icon>
			</div>
		)
	}else if(!notificationsData){
		return <Loader></Loader>;
	}

	const { notifications } = notificationsData.data;

	let notificationsPageContent = null;

	if (isLoading) {
		notificationsPageContent = <Loader></Loader>;
	} else if (isError) {
		notificationsPageContent = (
			<div>Error fetching post: {error.message}</div>
		);
	} else {
		return (
			<div className='notifications-link-container dropdown'>
				<Icon
					className='link-icon dropdown-toggle'
					data-bs-toggle='dropdown'
					data-bs-auto-close='outside'
				>
					notifications
				</Icon>
				<span className='notifications-count'>
					{notificationsData.data.unread}
				</span>
				<UserNotifications notifications={notifications} />
			</div>
		);
	}
};
export default NotificationsLink;
